import './tag.scss';
export const Tag = ({ render, title, action, changeClick }) => {
  return (
    <div
      className={`${action ? "action" : ""} tag-wraper`}
      onClick={() => changeClick()}
    >
      {render()}
      <span>{title}</span>
    </div>
  );
};
